/* reformly-plus-cart.js — standalone cart drawer for the Reformly Plus templates.
   Does NOT use liquid-ajax-cart. Talks to /cart.js, /cart/change.js, /cart/add.js.
   Opened by page ATC / nav cart / section CTAs via window.rypCart.open(). */
(function () {
  var root = document.getElementById('ryp-cart');
  if (!root) return;

  // Onboarding page only: the Next.js flow redirects here with ?email=, which we
  // forward to checkout so the email field is prefilled. Scoped to this template
  // so the other Plus pages keep a plain /checkout redirect.
  var EMAIL_PREFILL = root.getAttribute('data-ryp-template') === 'reformly-30-day-plan-onboarding';
  // 005/006/007: the subscription is summarised in a card under the board rather
  // than shown as its own locked line (matches the web005 capture).
  var R5 = root.getAttribute('data-ryp-r5') === '1';
  // Luna sells the board only as an upsell — its ATC adds the board variant and
  // nothing else, so no plan comes with it. Every other template carrying this
  // board either bundles a plan (OT001/2/3) or suppresses the note via R5.
  // data-ryp-luna, not the template suffix: luna-presale is the same page and
  // must behave identically, and a suffix comparison silently excluded it.
  var LUNA = root.getAttribute('data-ryp-luna') === '1';
  try {
    var qsEmail = EMAIL_PREFILL && new URLSearchParams(location.search).get('email');
    if (qsEmail && qsEmail.indexOf('@') > 0) sessionStorage.setItem('ryp_email', qsEmail);
  } catch (e) { }
  function emailParam() {
    var em;
    if (!EMAIL_PREFILL) return '';
    try { em = sessionStorage.getItem('ryp_email'); } catch (e) { }
    return em ? '?checkout%5Bemail%5D=' + encodeURIComponent(em) : '';
  }

  var panel = root.querySelector('[data-ryp-panel]');
  var linesEl = root.querySelector('[data-ryp-lines]');
  var countEl = root.querySelectorAll('[data-ryp-count]');
  var subtotalEl = root.querySelector('[data-ryp-subtotal]');
  var compareEl = root.querySelector('[data-ryp-compare]');
  var busy = false;
  // Bundled lines removed together with the board (membership + free gifts)
  var BUNDLED = ['data-ryp-membership', 'data-ryp-socks', 'data-ryp-nutrition', 'data-ryp-shipping']
    .map(function (a) { return parseInt(root.getAttribute(a), 10) || 0; })
    .filter(Boolean);
  var MEMBERSHIP = parseInt(root.getAttribute('data-ryp-membership'), 10) || 0;
  var MEM_MO = root.getAttribute('data-ryp-mem-mo') || '';
  var MEM_CADENCE = root.getAttribute('data-ryp-mem-cadence') || '/mo';
  var PLAN_LABEL = root.getAttribute('data-ryp-plan-label') || '30-Day';
  var MEM_PLAN = parseInt(root.getAttribute('data-ryp-mem-plan'), 10) || 0;
  // Every app-membership variant this cart may encounter. The active one comes from
  // data-ryp-membership; the rest are legacy bundles that can still be sitting in a
  // returning customer's cart. All are hidden/locked/bundled the same way, so a
  // template switching its membership doesn't strand the old line as removable.
  var MEMBERSHIP_VARIANTS = [
    46277813403705, // 30-day-plan-bundle subscription (current — reformly-30-day-plan)
    46250514874425, // 90-day-toned-transformation-plan subscription (reformly-90-day-plan)
    46133255798841, // yearly membership (legacy)
    46181559992377, // monthly membership (legacy july4 / onboarding option 2)
    45924536549433  // old membership (legacy)
  ];
  if (MEMBERSHIP && MEMBERSHIP_VARIANTS.indexOf(MEMBERSHIP) === -1) MEMBERSHIP_VARIANTS.push(MEMBERSHIP);
  function isMembership(vid) { return MEMBERSHIP_VARIANTS.indexOf(vid) !== -1; }

  /* Products the REFORMLY GOLD MEMBER order discount does NOT apply to.

     Must mirror MEMBERSHIP_PRODUCT_IDS in the discount function
     (reformly-gold-discount/extensions/gold-fn/src/eligibility.js). The
     function passes these as excludedCartLineIds, so Shopify never discounts
     them — allocate a share here and the membership renders below its real
     price while every other line is under-discounted by the difference.

     Deliberately NOT folded into isMembership(): that predicate also locks the
     row, hides the quantity controls, prints subscription billing terms and
     feeds the cart cleanup. This is only about who the order discount hits.

     By PRODUCT id, not variant, because the function matches on product. */
  var GOLD_PRODUCTS = [
    10311757004857, // Reformly Gold — intro, $0.99
    10311995326521  // Reformly Gold — swapped, $19.99
  ];
  function isGoldMembership(item) {
    return GOLD_PRODUCTS.indexOf(item.product_id) !== -1;
  }
  var BOARD_COMPARE = parseInt(root.getAttribute('data-ryp-board-compare'), 10) || 0; // MSRP (cents)
  /* ReformerX compare-at, variant id -> cents, emitted by the drawer snippet on
     the board PDP only. BOARD_COMPARE cannot serve here: it is a single value
     for the plan board and is gated behind isBoard(), which ReformerX is not
     part of. Empty object everywhere else, so every other template is unchanged. */
  var RFX_COMPARE = {};
  try { RFX_COMPARE = JSON.parse(root.getAttribute('data-ryp-rfx-compare') || '{}'); } catch (e) { }
  // Free gifts shown in the gift section, not as line items
  var GIFTS = ['data-ryp-socks', 'data-ryp-nutrition', 'data-ryp-shipping']
    .map(function (a) { return parseInt(root.getAttribute(a), 10) || 0; })
    .filter(Boolean)
    // 005/6/7 attach four more gift products; they arrive as a comma list so the
    // three fixed attributes above stay untouched for every other template.
    .concat((root.getAttribute('data-ryp-gifts-extra') || '')
      .split(',')
      .map(function (v) { return parseInt(v, 10) || 0; })
      .filter(Boolean));
  function isBoard(handle, vid) {
    return vid === 46240643776569 || vid === 46254864695353 || vid === 46302801690681 || vid === 46302882594873 || vid === 46302883151929 || vid === 46367085035577 || (handle || '').indexOf('reformly-board-30-day-plan') !== -1 || (handle || '').indexOf('reformly-board-90-day-plan') !== -1 || (handle || '').indexOf('reformly-pilates-board') !== -1;
  }
  // Mutually-exclusive subscription board variants (30-day std/discounted, 90-day, onboarding 90/30 quiz boards).
  // Only one may live in the cart at a time.
  var BOARD_VARIANTS = [46240643776569, 46254864695353, 46302801690681, 46302882594873, 46302883151929,
    46367085035577]; // reformly-pilates-board (005/006/007)

  // Hidden free gifts added elsewhere on the site (ReformerX etc.). Mirror of
  // reformly-free-gifts.js — the main cart auto-removes these when no qualifying
  // product is present; do the same here so orphaned gifts don't linger in this cart.
  // ponytail: keep these two lists in sync with reformly-free-gifts.js.
  var FREE_GIFT_HANDLES = [
    'reformerx-black', 'reformerx-pink', 'reformerx-purple', 'reformerx-black-1',
    'pilates-board-plan-purple', 'pilates-board-plan-black', 'pilates-board-plan-pink',
    'pilates-board-purple-summer-sale', 'pilates-board-black-summer-sale', 'pilates-board-pink-summer-sale',
    'pilates-basic-kit', 'pilates-basic-kit-1', 'pilates-basic-kit-2',
    'pilates-foundations-kit-1',
    'starter-sculpt-set', 'starter-sculpt-set-1', 'starter-sculpt-set-2',
    'total-tone-set', 'total-tone-set-1', 'total-tone-set-2',
    'pilates-power-set', 'pilates-power-set-1', 'pilates-power-set-2',
    'complete-studio-kit', 'complete-studio-set', 'complete-studio-set-1',
    // V4 kits (2026-10-06) — see the note on the same list in reformly-free-gifts.js.
    // Required here too: this list is the "is a qualifying product still present"
    // test, so without them enforceInvariants() would strip the gifts straight
    // back out after free-gifts.js adds them.
    'pilates-basic-kit-v2', 'starter-sculpt-kit-v2', 'pilates-essential-kit',
    'reformly-board-basic-kit', 'reformly-board-essentials-kit', 'reformly-board-pro-kit',
    'pilates-starter-kit',
    // OT001 landing page
    'reformly-pilates-board-1',
    // OT002 landing page
    'reformly-pilates-board-2',
    // OT003 landing page
    'reformly-pilates-board-3'
  ];
  var REFORMERX_GIFTS = [45947079491641, 45947083849785, 45947083096121];

  /* Mirrors KIT_GIFT_HANDLES in reformly-free-gifts.js — the boardless kits,
     which advertise the 30-Day Transformation Program in place of the 60-Day.
     Two lists kept in step by hand, the same arrangement FREE_GIFT_HANDLES
     already has with that file. The board+kit bundles are deliberately absent:
     if a board is in the bundle, the bundle promises what the board promises. */
  var KIT_GIFT_HANDLES = ['pilates-basic-kit-v2', 'pilates-starter-kit', 'pilates-essential-kit'];

  /* 30-day-transformation-program-digital-product, variant 50768361652281.
     Mirrors KIT_PROGRAM_GIFT_ID in reformly-free-gifts.js. Needed here so the
     "N Free Gifts – $X Value" header counts and prices a kit cart, whose
     programme line is not in REFORMERX_GIFTS. */
  var KIT_PROGRAM_GIFT_ID = 50768361652281;

  /* The two variants competing for the SINGLE programme cell, in priority
     order: the board's 60-Day first, the kit's 30-Day second. Mirrors the
     board-wins rule in effectiveGiftIds (reformly-free-gifts.js).

     Needed as well as that rule, not instead of it. The kit PDP's own ATC
     posts reformlyKitGiftIds, which still contains the 30-Day, so adding a kit
     to a cart that already holds a board puts BOTH programme lines in until
     the sweep removes the 30-Day one request later. Without this guard the
     drawer opens inside that window and renders five cells — a third row
     holding one — then reflows to four. The grid is four cells; it must not
     grow to five, even for a moment. */
  var PROGRAM_VIDS = [45947083849785, KIT_PROGRAM_GIFT_ID];

  // Board handles that legitimately carry a bundle — memberships/socks/etc. stay while any is present.
  var BOARD_HANDLES = [
    'pilates-board-plan-purple', 'pilates-board-plan-black', 'pilates-board-plan-pink',
    'pilates-board-purple-summer-sale', 'pilates-board-black-summer-sale', 'pilates-board-pink-summer-sale',
    'pilates-board-purple-4th-july-sale', 'pilates-board-black-4th-july-sale-yearly', 'pilates-board-pink-4th-july-sale-yearly',
    'pilates-board-purple-4th-july-sale-monthly', 'pilates-board-black-4th-july-sale-monthly', 'pilates-board-pink-4th-july-sale-monthly',
    'pilates-board-bonus',
    'reformly-board-30-day-plan', 'reformly-board-30-day-plan-discounted',
    'reformly-board-90-day-plan',
    'reformly-board-90-day-plan-quiz-offer', 'reformly-board-30-day-plan-quiz-offer',
    'reformly-pilates-board'   // 005/006/007 — one board, plan attached as a separate line
  ];
  // Bundle gift variants (memberships + socks + nutrition + shipping) across all Reformly bundles.
  // OT001 landing page — board variant -> its Transformation Program subscription.
  // Mirrors OT001_PLANS in reformly-free-gifts.js. Needed separately because that
  // file reacts to liquid-ajax-cart, while this cart talks to /cart.js directly —
  // so a removal made in the Plus drawer never reaches it and the subscription is
  // left orphaned. ponytail: keep both lists in sync.
  var OT001_PLANS = [
    { program: 46390418833465, boards: [46390404775993, 46390404808761, 46390404841529] }, // 28-Day
    // 60-Day — OT001's three colours plus OT002's, which sell the same program.
    {
      program: 46390421684281, boards: [
        46390405890105, 46390405955641, 46390406021177,
        46392279924793, 46392279957561, 46392279990329
      ]
    },
    { program: 46390424698937, boards: [46390405922873, 46390405988409, 46390406053945] }, // 90-Day
    // OT003 — its own intro program products; One Time Purchase has no program.
    { program: 46394724679737, boards: [46394757808185, 46394757906489, 46394758004793] }, // OT003 90-Day
    { program: 46394724417593, boards: [46394757775417, 46394757873721, 46394757972025] }, // OT003 60-Day
    // OT004 — one plan. Its One Time Purchase variants have no program, so they
    // are absent, exactly as OT003's are.
    { program: 46403509616697, boards: [46403501752377, 46403501850681, 46403501948985] }  // OT004 28-Day
  ];

  var BUNDLE_GIFT_VARIANTS = [
    46277813403705, // 30-day-plan-bundle subscription (current — reformly-30-day-plan)
    46250514874425, // 90-day-toned-transformation-plan subscription (reformly-90-day-plan)
    45924536549433, // old membership
    46133255798841, // yearly membership (july4 / r30 / reformly-plus)
    46181559992377, // monthly membership (july4 / onboarding option 2)
    45924805967929, // old socks
    45970505039929, // socks (summer / reformly-plus)
    46239945293881, // nutrition
    46239947489337, // express shipping
    // 005/006/007 gift products
    46367471304761, // nutrition (005)
    46367526322233, // 500+ guided classes
    46367553912889, // daily habit tracking
    46367574753337, // reformly community
    46367599099961  // 7-day kickstart challenge
  ];
  var enforcing = false; // guards the invariant-enforcement update (separate from `busy`)
  var lastCart = null;   // most recently rendered cart — used to scope bulk updates to real lines

  var startGiftAuto = function () { }; // set up by the gift carousel below
  var stopGiftAuto = function () { };

  // Cart totals that earn free shipping, in each currency's minor units — the
  // figures the Shipping & Returns FAQ quotes. Keyed off cart.currency, which
  // /cart.js reports as the ACTIVE market's currency, not the store default.
  //
  // There is deliberately no numeric fallback. A shopper in a market we have no
  // figure for (AED, CAD, AUD, JPY…) would otherwise be measured against 5000
  // of their own minor units — 50 AED is about a third of the real bar, so the
  // drawer would promise free shipping that checkout then charges for. Anything
  // not listed here hides the banner instead: no claim beats a wrong one.
  // Extend this map as markets get a published threshold.
  //
  // Deliberately NOT the maison drawer's figure. That one is
  // `free_shipping_threshold: 500` in settings_data.json, divided into
  // cart.total_price (CENTS) at maison-cart-drawer.liquid:1735 — i.e. $5, flat
  // across every currency, so the old bar read "unlocked" on essentially every
  // cart. These are the real thresholds.
  var SHIP_FREE_AT = { USD: 5000, EUR: 4500, GBP: 4500 };

  /* Product whose presence hides the bar entirely, ported from
     maison-cart-drawer.liquid:1726. Hardcoded there too, and the id appears
     nowhere else in the theme. */
  var SHIP_BAR_HIDDEN_FOR_PRODUCT = 8276074496057;

  var moneyFormat = window.rypMoneyFormat || '${{amount}}';
  /* Liquid's money_without_trailing_zeros, in JS. The gift grid shows "$99",
     not "$99.00" — that is what the design and the hero's gift tiles do.
     Only strips when the amount is whole, and matches either separator so a
     euro market's "€99,00" is handled as well as "$99.00". */
  function formatMoneyShort(cents) {
    var s = formatMoney(cents);
    return (cents || 0) % 100 === 0 ? s.replace(/([.,])00(?!\d)/, '') : s;
  }

  function formatMoney(cents) {
    cents = cents || 0;
    function fmt(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
      var cents2 = parts[1] ? (decimal || '.') + parts[1] : '';
      return dollars + cents2;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }

  // Shopify CDN resize. Uses the ?width= query param — the legacy _600x600
  // filename suffix isn't reliable on /cdn/shop/files/ URLs.
  function cdnResize(url, w) {
    if (!url) return '';
    var clean = url.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function isHidden(item) {
    if (isMembership(item.variant_id || item.id)) return true; // bundled membership, not shown as a line
    if (GIFTS.indexOf(item.variant_id || item.id) !== -1) return true;
    if (item.properties && item.properties._free_gift) return true;
    if (R5 && isMembership(item.variant_id || item.id)) return true;
    var tags = (item.product_tags || []);
    return tags.indexOf('MaisonNoShowCart') !== -1;
  }

  // "Free 30-Day Plan Included" callout that sits under the board line when the
  // cart has no subscription line of its own (product-only templates).
  function planNote() {
    var el = document.createElement('div');
    el.className = 'ryp-cart__plannote';
    el.innerHTML =
      '<img class="ryp-cart__plannote-img" src="https://cdn.shopify.com/s/files/1/0719/8470/9689/files/hi1234.webp?v=1785913655" alt="Reformly app 30 Day Plan" width="38" height="42" loading="lazy">' +
      '<span class="ryp-cart__plannote-text">' +
      '<span class="ryp-cart__plannote-title">Free ' + PLAN_LABEL + ' Plan Included</span>' +
      '<span class="ryp-cart__plannote-sub">Directly available in the Reformly app</span>' +
      '</span>';
    return el;
  }

  // "Your Transformation Plan:" card under the board when a subscription is
  // attached — the R5 counterpart to planNote(), which covers the no-subscription
  // case. Figures come off the membership line so they stay localised.
  // On 005 the plan is chosen at ATC, so it cannot come from a per-template
  // constant — PLAN_LABEL/MEM_CADENCE describe the template's default bundle and
  // would mislabel whichever plan the customer actually picked. Derive it from
  // the membership variant sitting in the cart instead.
  // months = billing-cycle length, used to show a per-month figure from a charge
  // that covers the whole cycle.
  var PLAN_BY_VARIANT = {
    46250514874425: { label: '90-Day', months: 3, cycle: 'billed every 12 weeks' },
    46277813403705: { label: '30-Day', months: 1, cycle: 'billed every 4 weeks' },
    46181559992377: { label: '30-Day', months: 1, cycle: 'billed monthly' }
  };

  // Label/cycle: prefer the variant map, then the product title, so an unmapped
  // membership still reads correctly instead of silently taking the template default.
  function planMeta(memItem) {
    var byId = PLAN_BY_VARIANT[memItem && (memItem.variant_id || memItem.id)];
    if (byId) return byId;
    var title = ((memItem && (memItem.product_title || memItem.title)) || '') + '';
    if (title.indexOf('90') !== -1) return { label: '90-Day', months: 3, cycle: 'billed every 12 weeks' };
    if (title.indexOf('30') !== -1) return { label: '30-Day', months: 1, cycle: 'billed every 4 weeks' };
    return { label: PLAN_LABEL, months: 1, cycle: '' };
  }

  // The RECURRING charge, not what is being paid today. The first month is free
  // (Seal applies a 100% discount to the initial order), so final_line_price is 0
  // and quoting it produced "auto-renews at $0.00". per_delivery_price is the
  // subscription's own per-cycle amount and survives the intro discount.
  function recurringCents(memItem) {
    if (!memItem) return 0;
    var qty = memItem.quantity || 1;
    var alloc = memItem.selling_plan_allocation;
    if (alloc) {
      if (alloc.per_delivery_price) return alloc.per_delivery_price;
      if (alloc.compare_at_price) return alloc.compare_at_price;
      if (alloc.price) return alloc.price;
    }
    if (memItem.original_price) return memItem.original_price;
    if (memItem.original_line_price) return memItem.original_line_price / qty;
    return 0;
  }

  function planCard(memItem) {
    var el = document.createElement('div');
    el.className = 'ryp-cart__plancard';
    var meta = planMeta(memItem);
    var cents = recurringCents(memItem);
    // Math.floor, never round: never quote a per-month figure above a month's
    // share of the real charge.
    var per = cents ? formatMoney(Math.floor(cents / meta.months)) : MEM_MO;
    var terms = 'First month free, then auto-renews at ' + per + '/mo'
      + (meta.cycle ? ' ' + meta.cycle : '') + ' \u2013 cancel anytime';
    el.innerHTML =
      '<span class="ryp-cart__plancard-title">Your Transformation Plan:</span>' +
      '<div class="ryp-cart__plancard-row">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>' +
      '<span class="ryp-cart__plancard-text">' +
      '<span class="ryp-cart__plancard-name">' + meta.label + ' Plan in the Reformly App</span>' +
      '<span class="ryp-cart__plancard-sub">' + terms + '</span>' +
      '</span></div>';
    return el;
  }

  /* Share of the ORDER-level discount belonging to this line.

     cart.js puts line-level discounts into final_line_price but leaves
     order-level ones out entirely — they live in
     cart_level_discount_applications with no per-line breakdown. So a cart with
     a 27% bundle and REFORMLY GOLD MEMBER on top rendered each sock at $16.06
     (bundle only) while checkout charged the equivalent of $14.46. Allocating
     the pool back down by line value is what the reference drawer does:
     7200 -> 5760 by the product discount, then -576 to 5184 on the line itself.

     The Gold membership is excluded from BOTH the pool's base and any
     allocation, because the discount function excludes it — count it in the
     base and the membership renders below its real price while every other line
     is under-discounted by its share. */
  function orderDiscountForLine(item) {
    var cart = lastCart;
    if (!cart) return 0;

    var apps = cart.cart_level_discount_applications || [];
    var pool = 0;
    for (var a = 0; a < apps.length; a++) pool += apps[a].total_allocated_amount || 0;
    if (pool <= 0) return 0;

    if (isGoldMembership(item)) return 0;

    var base = 0;
    cart.items.forEach(function (it) {
      if (isGoldMembership(it)) return;
      base += it.final_line_price;
    });
    if (base <= 0) return 0;

    return Math.round(pool * item.final_line_price / base);
  }

  function lineRow(item, index) {
    var wrap = document.createElement('div');
    wrap.className = 'ryp-cart__line';
    var img = cdnResize(item.image, 320);
    /* Net of BOTH discount classes, so the row agrees with checkout. */
    var lineNet = item.final_line_price - orderDiscountForLine(item);
    var unitNet = lineNet / item.quantity;
    var price = formatMoney(unitNet);
    // strikethrough = line discount, or the board's compare-at MSRP (cart.js
    // doesn't expose compare_at per line, so we pass BOARD_COMPARE from Liquid)
    var compareUnit = item.original_price;
    if (isBoard(item.handle, item.variant_id || item.id) && BOARD_COMPARE > compareUnit) {
      compareUnit = BOARD_COMPARE;
    }
    // ReformerX: same idea, but keyed per variant since the three colours are
    // separate products. Matches the PDP, which strikes $199 through $119.
    var rfxCmp = RFX_COMPARE[item.variant_id || item.id];
    if (rfxCmp > compareUnit) compareUnit = rfxCmp;
    /* Every other product's compare-at, from the Liquid section — see
       fetchCompare(). The two hardcoded maps above stay: they are read
       synchronously from the snippet's attributes, so the first paint on the
       board PDP has its strikethrough before this map has landed. */
    var cmp = COMPARE[item.variant_id || item.id];
    if (cmp > compareUnit) compareUnit = cmp;
    var compare = compareUnit > unitNet
      ? '<span class="ryp-cart__line-was">' + formatMoney(compareUnit) + '</span>' : '';
    // membership subscription: no qty edit / remove, show billing terms
    var planId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id : 0;
    var locked = isMembership(item.variant_id || item.id) && planId > 0;
    var priceHtml = locked
      ? '<span class="ryp-cart__line-billing">First 4 weeks free, then ' + MEM_MO + MEM_CADENCE + '. Cancel anytime.</span>'
      : '<span class="ryp-cart__line-price">' + price + '</span>' + compare;
    var controls = locked ? '' :
      '<div class="ryp-cart__line-controls">' +
      '<div class="ryp-cart__qty">' +
      '<button type="button" class="ryp-cart__qty-btn" data-ryp-qty="dec" data-line="' + (index + 1) + '" data-ryp-key="' + (item.key || '') + '" aria-label="Decrease">–</button>' +
      '<span class="ryp-cart__qty-num">' + item.quantity + '</span>' +
      '<button type="button" class="ryp-cart__qty-btn" data-ryp-qty="inc" data-line="' + (index + 1) + '" data-ryp-key="' + (item.key || '') + '" aria-label="Increase">+</button>' +
      '</div>' +
      '<button type="button" class="ryp-cart__remove" data-ryp-remove="' + (index + 1) + '" data-ryp-key="' + (item.key || '') + '" data-ryp-variant="' + (item.variant_id || item.id) + '" data-ryp-handle="' + (item.handle || '') + '">Remove</button>' +
      '</div>';
    wrap.innerHTML =
      '<div class="ryp-cart__line-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="ryp-cart__line-info">' +
      '<span class="ryp-cart__line-name">' + item.product_title + '</span>' +
      '<div class="ryp-cart__line-prices">' + priceHtml + '</div>' +
      controls +
      '</div>';
    return wrap;
  }

  // Enforce cart invariants and re-render on the cleaned cart. Runs on its own `enforcing`
  // flag (NOT the mutation `busy` flag) so it still fires on the render that follows a
  // remove — otherwise orphaned gifts only clear after the user reopens the cart.
  // Batches everything into one /cart/update.js:
  //  1) Only one board variant (standard vs discounted) may exist — keep the last-added.
  //  2) Hidden free gifts (ReformerX / _free_gift) removed when no qualifying product present.
  //  3) Bundle gifts (memberships + socks + nutrition + shipping) removed when no board present.
  // Mirrors reformly-free-gifts.js. ponytail: keep the handle/variant lists in sync with it.
  function enforceInvariants(cart) {
    if (enforcing) return false;
    var updates = {};
    var boardLines = cart.items.filter(function (it) { return BOARD_VARIANTS.indexOf(it.variant_id || it.id) !== -1; });
    if (boardLines.length > 1) {
      var keep = boardLines[boardLines.length - 1];
      boardLines.forEach(function (it) { if (it !== keep) updates[it.variant_id || it.id] = 0; });
    }
    // OT003's One Time Purchase variants don't earn the gift set, and they share
    // a handle with the two plans that do — so they're excluded by variant id.
    // ponytail: keep in sync with OT003_ONE_TIME_BOARDS in reformly-free-gifts.js.
    var OT003_ONE_TIME_BOARDS = [46394757742649, 46394757840953, 46394757939257];
    var hasGiftTrigger = cart.items.some(function (it) {
      var vid = it.variant_id || it.id;
      if (OT003_ONE_TIME_BOARDS.indexOf(vid) !== -1) return false;
      return FREE_GIFT_HANDLES.indexOf(it.handle) !== -1;
    });
    if (!hasGiftTrigger) {
      cart.items.forEach(function (it) {
        var vid = it.variant_id || it.id;
        if ((it.properties && it.properties._free_gift) || REFORMERX_GIFTS.indexOf(vid) !== -1) updates[vid] = 0;
      });
    }
    // OT001: each program's quantity tracks its own plan's board quantity, so a
    // cart holding two plans only loses the subscription for the board removed,
    // and dropping a board from qty 2 to 1 leaves one subscription rather than
    // two. Zero boards means zero program, which covers removal.
    OT001_PLANS.forEach(function (plan) {
      var boardQty = 0;
      var programLine = null;
      cart.items.forEach(function (it) {
        var vid = it.variant_id || it.id;
        if (plan.boards.indexOf(vid) !== -1) boardQty += it.quantity;
        if (vid === plan.program) programLine = it;
      });
      if (programLine && programLine.quantity !== boardQty) {
        updates[plan.program] = boardQty;
      }
    });

    // OT003's subscription boards count as a board here. Without them the sweep
    // below would wipe the Personalized Nutrition Plan that OT003 grants as a
    // gift, since that variant is in BUNDLE_GIFT_VARIANTS.
    // ponytail: keep in sync with OT003_GIFT_BOARDS in reformly-free-gifts.js.
    var OT003_GIFT_BOARDS = [
      46394757808185, 46394757906489, 46394758004793,
      46394757775417, 46394757873721, 46394757972025
    ];
    var hasBoard = cart.items.some(function (it) {
      var vid = it.variant_id || it.id;
      return BOARD_VARIANTS.indexOf(vid) !== -1 ||
        OT003_GIFT_BOARDS.indexOf(vid) !== -1 ||
        BOARD_HANDLES.indexOf(it.handle) !== -1;
    });
    /* A page that SELLS a membership standalone must not have it swept as an
       orphan. BUNDLE_GIFT_VARIANTS contains the memberships, so without this
       the sweep below deletes the thing the buyer just added the moment it
       lands in a cart with no board.

       Not a problem before this drawer went site-wide: the membership pages
       rendered the maison drawer, so this code never ran there. It is the same
       guard, and the same selector, that reformly-free-gifts.js:930 uses for
       its own version of this sweep — .rmh__page covers the four
       reformly-membership-hero* pages, [data-membership-standalone] is the
       opt-in marker app-membership-002/003 use via reformly-am002-hero.
       ponytail: keep the selector in sync with that file. */
    var isMembershipPage = !!document.querySelector('.rmh__page, [data-membership-standalone]');
    if (!hasBoard && !isMembershipPage) {
      cart.items.forEach(function (it) {
        var vid = it.variant_id || it.id;
        if (BUNDLE_GIFT_VARIANTS.indexOf(vid) !== -1) updates[vid] = 0;
      });
    }
    if (!Object.keys(updates).length) return false;
    enforcing = true;
    root.classList.add('ryp-cart--loading');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .catch(function () { })
      .then(function (c) {
        enforcing = false;
        root.classList.remove('ryp-cart--loading');
        if (c && c.items) render(c);
        if (c && c.item_count === 0) close(); // cleanup emptied the cart → close like afterMutate
      });
    return true;
  }

  function render(cart) {
    lastCart = cart;
    if (enforceInvariants(cart)) return; // fired a cleanup → it re-renders with the clean cart
    var visible = cart.items.filter(function (it) { return !isHidden(it); });
    var visibleCount = visible.reduce(function (n, it) { return n + it.quantity; }, 0);
    // Counter reflects the true cart total (incl. hidden free gifts) so it doesn't flicker down
    var count = cart.item_count;

    /* "Your Cart (n)" counts what the drawer actually LISTS, everywhere.

       The raw item_count includes the hidden gift lines, so a cart holding one
       board read "Your Cart (4)" above a single visible row — which is what the
       maison drawer never did, and what made the count look wrong on every page
       except the board PDP.

       This was opt-in via data-ryp-count-visible, set only on
       sjoerd-maison-pdp-v3. The argument for opt-in was that the plan templates
       add their gifts in a SECOND request, so a visible count ticks up after the
       fact rather than landing correct. That is a brief flicker on those
       templates; the alternative is a permanently wrong number on all the
       others. Flicker loses. The attribute stays on the snippet and is simply
       no longer read. */
    countEl.forEach(function (el) { el.textContent = visibleCount; });
    /* Keep the header/nav cart badge in sync (old cart did this via
       liquid-ajax-cart). visibleCount, matching "Your Cart (n)" above and the
       theme badge below — three counters on one page disagreeing by the number
       of hidden gift lines is worse than any of them being off. */
    document.querySelectorAll('[data-rj4-cart-count]').forEach(function (el) {
      el.textContent = visibleCount;
      el.classList.toggle('rj4__hidden', visibleCount === 0);
    });

    /* Theme header badge. Most templates on this drawer hide the header
       entirely, but the board PDP keeps the old nav — and its
       .cart-count-bubble is server-rendered Liquid that used to be refreshed by
       liquid-ajax-cart via the maison drawer. Neither runs here, so the badge
       sat frozen at its page-load value.

       VISIBLE count, not `count`: sections/header.liquid sums quantities
       excluding _free_gift and MaisonNoShowCart, which is exactly isHidden().
       Using the raw item_count would make the badge jump to 4 the moment the
       three hidden ReformerX gifts land. Where no header renders this finds
       nothing and does nothing. */
    var bubbles = document.querySelectorAll('.cart-count-bubble');

    /* Liquid only emits the bubble when the count is already above zero, so on
       a cart that started empty there is no element to update and the badge
       could never appear before a reload. Build it the first time, matching
       header.liquid's markup. */
    if (!bubbles.length && visibleCount > 0) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        var made = document.createElement('div');
        made.className = 'cart-count-bubble';
        made.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        icon.appendChild(made);
        bubbles = document.querySelectorAll('.cart-count-bubble');
      }
    }

    bubbles.forEach(function (el) {
      var span = el.querySelector('span[aria-hidden]');
      if (span) span.textContent = visibleCount;
      var sr = el.querySelector('.visually-hidden');
      if (sr) sr.textContent = visibleCount + ' items';
      el.style.display = visibleCount > 0 ? '' : 'none';
    });
    // subscription lines are hidden, so check the raw cart rather than `visible`
    var hasMembershipLine = cart.items.some(function (it) {
      return isMembership(it.variant_id || it.id);
    });
    if (linesEl) {
      linesEl.innerHTML = '';
      visible.forEach(function (it, i) {
        // index in the FULL cart line list (change.js uses 1-based line over all items)
        var fullIndex = cart.items.indexOf(it);
        linesEl.appendChild(lineRow(it, fullIndex));
        if (isBoard(it.handle, it.variant_id || it.id)) {
          // The card requires BOTH a board line and a real subscription line —
          // a membership variant that actually carries a selling plan. A bare
          // membership variant with no plan attached is a one-off, not a
          // subscription, and must not be described as auto-renewing.
          var subLine = R5 ? cart.items.filter(function (m) {
            var planId = m.selling_plan_allocation && m.selling_plan_allocation.selling_plan
              ? m.selling_plan_allocation.selling_plan.id : 0;
            return isMembership(m.variant_id || m.id) && planId > 0;
          })[0] : null;

          if (subLine) {
            linesEl.appendChild(planCard(subLine));
          } else if (!R5 && !LUNA && !hasMembershipLine) {
            // Plan included rather than subscribed — say so under the board.
            // Not on R5: there the board is sold on its own and no plan is
            // bundled, so this would promise a free plan the customer is not
            // getting. The Kickstart gift slide covers what they do receive.
            linesEl.appendChild(planNote());
          }
        }
      });
    }
    // Bold subtotal = what you actually pay (gifts are $0).
    // Strikethrough = board price + the free gifts' full retail value, so the
    // gifts count toward the crossed-out "before" total. Board uses its compare-at
    // MSRP when higher (cart.js doesn't expose compare_at per line).
    var subFinal = cart.total_price;
    var subOrig = cart.items.reduce(function (n, it) {
      var vid = it.variant_id || it.id;
      var base = it.original_line_price || it.final_line_price;
      if (isBoard(it.handle, vid) && BOARD_COMPARE) {
        base = Math.max(base, BOARD_COMPARE * it.quantity);
      }
      // Same map the line rows use, so the subtotal's "was" agrees with the
      // strikethroughs above it instead of only counting the board's.
      if (RFX_COMPARE[vid]) base = Math.max(base, RFX_COMPARE[vid] * it.quantity);
      if (COMPARE[vid]) base = Math.max(base, COMPARE[vid] * it.quantity);
      return n + base;
    }, 0);
    if (subtotalEl) subtotalEl.textContent = formatMoney(subFinal);
    if (compareEl) {
      if (subOrig > subFinal) {
        compareEl.textContent = formatMoney(subOrig);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    // Free gifts / shipping / discount / upsells only when the bundle board
    // (reformly-board-30-day-plan) is in the cart, not the one-time bonus board.
    var hasBoard = cart.items.some(function (it) {
      return isBoard(it.handle, it.variant_id || it.id);
    });
    // One-time-purchase (bonus) board — upsells show for it too, but not gifts/shipping/discount
    var OTP_VIDS = [45870676115513, 45870676148281, 45870676181049];
    var hasOtpBoard = cart.items.some(function (it) {
      return (it.handle || '').indexOf('pilates-board-bonus') !== -1
        || OTP_VIDS.indexOf(it.variant_id || it.id) !== -1;
    });
    // discount banner shows unless the one-time-purchase product is in the cart
    root.classList.toggle('ryp-cart--has-board', !hasOtpBoard);
    /* Free-shipping banner: any non-empty cart, matching the maison drawer.

       Was `hasBoard || hasOtpBoard || hasRfxBoard`, written when this drawer
       only ran on board pages — where "is there a board" and "is the cart
       non-empty" were the same question. Site-wide that hid the bar on every
       accessory cart, which is exactly where it earns.

       The one exclusion is maison's, ported verbatim. */
    var shipBarHidden = cart.items.some(function (it) {
      return it.product_id === SHIP_BAR_HIDDEN_FOR_PRODUCT;
    });
    root.classList.toggle('ryp-cart--ship-on', cart.items.length > 0 && !shipBarHidden);
    // free gifts show only when all three gift items are actually in the cart
    var hasAllGifts = GIFTS.every(function (id) {
      return cart.items.some(function (it) { return (it.variant_id || it.id) === id; });
    });
    root.classList.toggle('ryp-cart--bundle', hasAllGifts || (R5 && hasBoard));
    root.classList.toggle('ryp-cart--empty', count === 0);

    // Free-shipping banner. It used to claim the shipping was already free the
    // moment it was shown, which is only true above the threshold — a single
    // Luna alarm is $39.99 and does not reach it, so the banner contradicted
    // what the buyer would be charged. Below the threshold it now counts down
    // instead, and the bar tracks progress rather than sitting full.
    //
    // The thresholds are the ones quoted in the Shipping & Returns FAQ. An
    // unrecognised currency falls back to the USD figure rather than to a
    // promise, so the worst case is asking for slightly too much, never too
    // little. Boards are well past it either way, so nothing changes on the
    // 005/006/007 carts, where this banner only appears alongside one.
    // Footer badge swap: the wake-up guarantee replaces Free Shipping only while
    // the product it belongs to is in the cart. Handle comes from the template,
    // so this is inert everywhere the attribute is empty.
    var guaranteeHandle = root.getAttribute('data-ryp-guarantee-handle');
    root.classList.toggle('ryp-cart--guarantee', !!guaranteeHandle && cart.items.some(function (it) {
      return (it.handle || '') === guaranteeHandle;
    }));

    var shipText = root.querySelector('.ryp-cart__ship-text');
    var shipFill = root.querySelector('.ryp-cart__ship-fill');
    var freeAt = SHIP_FREE_AT[cart.currency];
    // No published threshold for this market — hide rather than guess.
    root.classList.toggle('ryp-cart--ship-unknown', !freeAt);
    if (shipText && shipFill && freeAt) {
      var shortBy = freeAt - (cart.total_price || 0);
      if (shortBy > 0) {
        shipText.innerHTML = 'Spend <strong>' + formatMoney(shortBy) + '</strong> more and get free shipping!';
        shipFill.style.width = Math.max(0, Math.min(100, ((cart.total_price || 0) / freeAt) * 100)) + '%';
      } else {
        shipText.innerHTML = 'Congrats! You’ve unlocked <strong>FREE SHIPPING!</strong>';
        shipFill.style.width = '100%';
      }
    }

    // Upsell tiles stay visible; the button flips to "Added" when any variant of
    // that product is in the cart (variants differ by colour/size, so match on handle).
    var inCartHandles = {};
    cart.items.forEach(function (it) { if (it.handle) inCartHandles[it.handle] = true; });
    root.querySelectorAll('[data-ryp-tile-handle]').forEach(function (btn) {
      var added = !!inCartHandles[btn.getAttribute('data-ryp-tile-handle')];
      btn.classList.toggle('is-added', added);
      if (!btn.classList.contains('is-loading')) btn.textContent = added ? 'Added' : 'Add to cart';
    });
    // Show the variant the shopper actually added, so the tile photo matches its
    // cart line; fall back to the server-rendered default once it's removed.
    root.querySelectorAll('[data-ryp-tile]').forEach(function (tile) {
      var im = tile.querySelector('img');
      if (!im) return;
      if (!im.getAttribute('data-ryp-default-src')) {
        im.setAttribute('data-ryp-default-src', im.getAttribute('src') || '');
      }
      var line = cart.items.filter(function (it) { return it.handle === tile.getAttribute('data-ryp-tile'); })[0];
      var next = (line && line.image)
        ? cdnResize(line.image, 600)
        : im.getAttribute('data-ryp-default-src');
      if (next && im.getAttribute('src') !== next) { im.removeAttribute('srcset'); im.src = next; }
    });
    if (R5) {
      var hasSub = cart.items.some(function (m) {
        var pid = m.selling_plan_allocation && m.selling_plan_allocation.selling_plan
          ? m.selling_plan_allocation.selling_plan.id : 0;
        return isMembership(m.variant_id || m.id) && pid > 0;
      });
      // Capture writes 'Free with your ' + plan title, so the subline names the
      // plan actually in the cart rather than a generic "your plan".
      var subLbl = null;
      if (hasSub) {
        var sub5 = cart.items.filter(function (m) {
          var pid = m.selling_plan_allocation && m.selling_plan_allocation.selling_plan
            ? m.selling_plan_allocation.selling_plan.id : 0;
          return isMembership(m.variant_id || m.id) && pid > 0;
        })[0];
        subLbl = 'Free with your ' + planMeta(sub5).label + ' Plan';
      }
      var slides = root.querySelectorAll('.ryp-cart__gift-slide');
      var shown = 0;
      slides.forEach(function (sl) {
        var when = sl.getAttribute('data-gift-when');
        var show = !when || (when === 'plan' ? hasSub : !hasSub);
        sl.style.display = show ? '' : 'none';
        if (show) shown++;
        if (when === 'plan' && subLbl) {
          var subEl = sl.querySelector('.ryp-cart__gift-sub');
          if (subEl) subEl.textContent = subLbl;
        }
      });
      // Dots are static markup — keep only as many as there are visible slides,
      // and reset to the first so the carousel and the indicator agree.
      var dots = root.querySelectorAll('[data-ryp-gift-dots] .ryp-cart__gift-dot');
      dots.forEach(function (d, i) {
        d.style.display = i < shown ? '' : 'none';
        d.classList.toggle('is-active', i === 0);
      });
      var gc = root.querySelector('[data-ryp-gift-carousel]');
      if (gc) gc.scrollLeft = 0;
    }

    /* Both upsell rails show for any non-empty cart.

       They used to key off a board being present, with data-ryp-upsells-any as
       the opt-out for the two templates where that test never passes — Luna
       sells an alarm, and the ReformerX PDP sells a board that is not in
       BOARD_VARIANTS. Now that this drawer is the whole store's cart, the board
       test would hide the accessories rail on every ordinary product page,
       which is exactly where it earns. The attribute stays on the snippet so
       nothing breaks; it simply no longer changes the outcome. */
    var complete = root.querySelector('[data-ryp-complete]');
    if (complete) complete.style.display = count > 0 ? '' : 'none';

    /* ReformerX free-gift grid. Shown only when those gifts are actually in the
       cart, which is the same thing as saying a ReformerX board is — nothing
       else adds them. That keeps this off every other template on this drawer
       without needing a template test.

       Prices come from the line's `price`, not `final_price`: the gift is
       discounted to zero, so final_price is 0 and the struck value would read
       "$0". `price` still carries what the product costs, which is the number
       the design strikes through. Localised for free, since it is cart money. */
    var rfx = root.querySelector('[data-ryp-rfx]');
    if (rfx) {
      var byVid = {};
      cart.items.forEach(function (it) { byVid[it.variant_id || it.id] = it; });

      var present = 0;
      var worth = 0;

      /* Which programme owns the single cell. Board's 60-Day beats the kit's
         30-Day, matching effectiveGiftIds in reformly-free-gifts.js — see the
         note on PROGRAM_VIDS for why both lines can be present at once. */
      var activeProgram = 0;
      for (var pi = 0; pi < PROGRAM_VIDS.length; pi++) {
        if (byVid[PROGRAM_VIDS[pi]]) { activeProgram = PROGRAM_VIDS[pi]; break; }
      }

      root.querySelectorAll('[data-ryp-rfx-cell]').forEach(function (cell) {
        var vid = cell.getAttribute('data-ryp-rfx-vid');
        // Community Access has no line item — always shown, always "Priceless".
        if (!vid) { present++; return; }
        var line = byVid[vid];
        var was = cell.querySelector('[data-ryp-rfx-was]');
        // A losing programme cell stays hidden even while its line is still in
        // the cart, so the grid never shows two of them.
        if (PROGRAM_VIDS.indexOf(Number(vid)) !== -1 && Number(vid) !== activeProgram) {
          cell.hidden = true;
          return;
        }
        cell.hidden = !line;
        if (!line) return;
        present++;
        /* Unit price, not line total, and the badge stays at the static 1 the
           export renders. The gift set is one per CART, not per board: buying
           two boards still earns three gifts, which is what free-gifts.js
           enforces (:814, "ensure quantity stays at 1"). Writing line.quantity
           here made the badge read 2 whenever a stray duplicate existed. */
        worth += line.price;
        if (was) was.textContent = formatMoneyShort(line.price);
      });

      /* KIT_PROGRAM_GIFT_ID as well as the shared trio: on a boardless kit the
         60-Day line is absent and the 30-Day is present, so testing only
         REFERMERX_GIFTS would hide the whole block on exactly the carts the
         swap exists for. */
      var anyGift = REFORMERX_GIFTS.concat([KIT_PROGRAM_GIFT_ID]).some(function (id) { return byVid[id]; });
      rfx.hidden = !anyGift;
      if (anyGift) {
        var cnt = rfx.querySelector('[data-ryp-rfx-count]');
        var val = rfx.querySelector('[data-ryp-rfx-value]');
        if (cnt) cnt.textContent = present;
        if (val) val.textContent = formatMoneyShort(worth) + ' Value';
      }
    }

    // Gift prices reflect the actual discounted line price (automatic discount)
    var giftPrice = {};
    cart.items.forEach(function (it) {
      giftPrice[it.variant_id || it.id] = it.final_price;
    });
    root.querySelectorAll('[data-ryp-gift-price]').forEach(function (el) {
      var vid = parseInt(el.getAttribute('data-ryp-gift-price'), 10);
      if (giftPrice[vid] != null) el.textContent = formatMoney(giftPrice[vid]);
    });
  }

  /* Compare-at prices, variant id -> cents.

     /cart.js has no compare_at_price — only original_price, which reflects
     DISCOUNTS. So a product with a compare-at set in admin showed no
     strikethrough in this drawer, while the maison drawer showed one because
     liquid-ajax-cart re-rendered it server-side where Liquid could read it.

     sections/reformly-cart-compare.liquid emits the map for the current cart;
     see the note in that file for why this rather than /products/<handle>.js
     per line or a Liquid map baked into the page. */
  var COMPARE = {};

  function fetchCompare() {
    return fetch('/?sections=reformly-cart-compare', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var el = new DOMParser()
          .parseFromString(data['reformly-cart-compare'] || '', 'text/html')
          .getElementById('ryp-compare-data');
        COMPARE = el ? JSON.parse(el.textContent) : {};
      })
      /* A failed or malformed fetch must not stop the cart rendering — the
         drawer just falls back to no strikethrough, which is what it did
         before this existed. Keep the previous map rather than clearing it. */
      .catch(function () { });
  }

  function fetchCart() {
    /* Both in flight at once. The compare map depends on the cart's contents,
       so it cannot be skipped until the cart arrives — but waiting for
       /cart.js first would make this two round trips instead of one wait. */
    return Promise.all([
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
      fetchCompare()
    ]).then(function (out) {
      var cart = out[0];
      render(cart);
      return cart;
    });
  }

  function afterMutate(cart) {
    render(cart);
    if (cart.item_count === 0) close(); // no items left → close the cart

    /* TELL THE GIFT ENGINES THE CART MOVED.

       This drawer talks to /cart/change.js and /cart/update.js directly, so a
       removal or quantity change here produces no `liquid-ajax-cart:request-end`
       — and that event is the ONLY thing reformly-free-gifts.js:1272 listens
       for. Adds already get this nudge (see the request-end block further
       down); removals did not, so a gift whose trigger had just been removed
       was never swept.

       The visible symptom: remove a kit from a board+kit cart and its 30-Day
       Program stayed behind, because nothing re-ran effectiveGiftIds() to
       notice it had gone stale.

       update({}) is a bare POST /cart/update.js — nothing is registered as
       [data-ajax-cart-section] since the maison drawer was retired, so it does
       not re-render anything. It exists purely to emit the event.

       Routed through kickLiquidAjaxCart() rather than calling update()
       directly: that helper already defers and checks lacInFlight / lacLast,
       so a drawer mutation cannot fire a second request on top of one the gift
       engine is already making, while `force` keeps the staleness guard from
       swallowing a removal that nothing else would reconcile. */
    kickLiquidAjaxCart(true);
  }

  /* TARGET THE LINE KEY, NOT ITS POSITION.

     `line` is an index into the cart as it stood when the drawer last
     rendered. The gift engine mutates the cart asynchronously, so by the time
     a click lands that index can point at a different row — pressing Remove on
     a kit deleted the 30-Day Program sitting one row above it, and the kit
     stayed. A second press then worked, because the re-render had realigned
     the indices.

     /cart/change.js accepts a line item key as `id`, which identifies a line
     by its variant AND properties, so it survives reordering and cannot
     collide with another line of the same variant (a paid copy vs a gift copy).
     `line` is kept as the fallback for callers that have no key. */
  function changeLine(line, qty, key) {
    if (busy) return;
    busy = true;
    root.classList.add('ryp-cart--loading');
    var target = key ? { id: key, quantity: qty } : { line: line, quantity: qty };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(target)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { afterMutate(cart); })
      .catch(function () { })
      .then(function () { busy = false; root.classList.remove('ryp-cart--loading'); });
  }

  // Removing the board also removes its bundled app membership + free socks
  function removeBundle(boardVid) {
    if (busy) return;
    busy = true;
    root.classList.add('ryp-cart--loading');
    // Only name lines that are actually in the cart: /cart/update.js 422s on a
    // variant id it can't resolve (e.g. a retired legacy membership), which would
    // abort the whole removal and leave the board sitting there.
    var inCart = {};
    ((lastCart && lastCart.items) || []).forEach(function (it) { inCart[it.variant_id || it.id] = true; });
    var updates = {};
    updates[boardVid] = 0;
    BUNDLED.forEach(function (id) { if (inCart[id]) updates[id] = 0; });
    // also clear any legacy membership line left over from a previous bundle
    MEMBERSHIP_VARIANTS.forEach(function (id) { if (inCart[id]) updates[id] = 0; });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { afterMutate(cart); })
      .catch(function () { })
      .then(function () { busy = false; root.classList.remove('ryp-cart--loading'); });
  }

  // ── Quick view ──────────────────────────────────────────────────────────────
  // Product/variant data is inlined by the drawer snippet, so opening the panel
  // costs no network round-trip.
  var PRODUCTS = {};
  try {
    var pdEl = document.getElementById('ryp-cart-products');
    if (pdEl) PRODUCTS = JSON.parse(pdEl.textContent) || {};
  } catch (err) { PRODUCTS = {}; }

  // A page may contribute its OWN products to the quick view. This table is
  // built from the drawer's upsell handles only, so a rail showing anything
  // else (the socks PDP's bestsellers, for one) would open nothing on press —
  // openQuick() returns silently when the handle is absent.
  //
  // Additive and optional: sections emit `#ryp-cart-products-extra` in the same
  // schema and it is merged here. Drawer entries win on a clash, so a page
  // cannot change what the cart itself offers. No effect on any page that does
  // not emit the element.
  // querySelectorAll, not getElementById: a page can render the contributing
  // section more than once (the socks PDP has two product rails), and an id
  // lookup would see only the first.
  try {
    var extras = document.querySelectorAll('[data-ryp-products-extra]');
    for (var xi = 0; xi < extras.length; xi++) {
      var extra = JSON.parse(extras[xi].textContent) || {};
      for (var eh in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, eh) && !PRODUCTS[eh]) PRODUCTS[eh] = extra[eh];
      }
    }
  } catch (err2) { }

  var quickEl = document.getElementById('ryp-quick');
  var quickHandle = null;
  var quickChoice = [];
  var quickSrcBtn = null;

  function matchVariant(p, choice) {
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var ok = true;
      for (var j = 0; j < choice.length; j++) {
        if (choice[j] != null && v.options[j] !== choice[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function renderQuick() {
    var p = PRODUCTS[quickHandle];
    if (!p || !quickEl) return;
    var v = matchVariant(p, quickChoice);
    var img = (v && v.image) || p.image || '';
    var imgEl = quickEl.querySelector('[data-ryp-quick-img]');
    if (imgEl && imgEl.getAttribute('src') !== img) {
      // Fade out while the new file decodes — otherwise the previous product's
      // photo stays on screen for a beat after the panel switches.
      imgEl.classList.add('is-swapping');
      var reveal = function () { imgEl.classList.remove('is-swapping'); };
      imgEl.onload = reveal;
      imgEl.onerror = reveal;
      imgEl.src = img;
      imgEl.alt = p.title;
      if (imgEl.complete) reveal(); // already cached — no load event coming
    }
    quickEl.querySelector('[data-ryp-quick-name]').textContent = p.title;
    quickEl.querySelector('[data-ryp-quick-price]').textContent = (v && v.price) || p.price;

    var optsEl = quickEl.querySelector('[data-ryp-quick-opts]');
    optsEl.innerHTML = '';
    p.options.forEach(function (opt, oi) {
      if (opt.values.length < 2) return;
      var swatches = opt.values.some(function (val) { return !!val.swatch; });
      var group = document.createElement('div');
      group.className = 'ryp-quick__opt';
      var label = document.createElement('span');
      label.className = 'ryp-quick__opt-label';
      label.textContent = opt.name + ': ' + (quickChoice[oi] || '');
      group.appendChild(label);
      var row = document.createElement('div');
      row.className = 'ryp-quick__opt-row';
      opt.values.forEach(function (val) {
        var probe = quickChoice.slice();
        probe[oi] = val.label;
        var pv = matchVariant(p, probe);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-ryp-quick-opt', oi);
        btn.setAttribute('data-ryp-quick-val', val.label);
        var active = quickChoice[oi] === val.label;
        if (swatches && val.swatch) {
          btn.className = 'ryp-quick__swatch' + (active ? ' is-active' : '');
          btn.style.background = val.swatch;
          btn.title = val.label;
          btn.setAttribute('aria-label', val.label);
        } else {
          btn.className = 'ryp-quick__chip' + (active ? ' is-active' : '');
          btn.textContent = val.label;
        }
        if (pv && !pv.available) btn.classList.add('is-soldout');
        row.appendChild(btn);
      });
      group.appendChild(row);
      optsEl.appendChild(group);
    });

    var addable = v && v.available;
    quickEl.querySelectorAll('[data-ryp-quick-add]').forEach(function (b) {
      b.disabled = !addable;
      b.textContent = addable ? 'Add to cart' : 'Sold out';
    });
  }

  function openQuick(handle) {
    var p = PRODUCTS[handle];
    if (!p || !quickEl) return;
    quickHandle = handle;
    // remember the tile that opened this, so its button can show the adding state
    quickSrcBtn = root.querySelector('[data-ryp-tile-handle="' + handle + '"]');
    // Default to the first available variant's options
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    quickChoice = first ? first.options.slice() : [];
    quickEl.hidden = false;
    document.body.classList.add('ryp-quick-open');
    renderQuick();
  }

  function closeQuick() {
    if (!quickEl) return;
    quickEl.hidden = true;
    quickHandle = null;
    document.body.classList.remove('ryp-quick-open');
  }

  if (quickEl) {
    quickEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-ryp-quick-close]')) { closeQuick(); return; }
      var opt = e.target.closest('[data-ryp-quick-opt]');
      if (opt) {
        quickChoice[parseInt(opt.getAttribute('data-ryp-quick-opt'), 10)] = opt.getAttribute('data-ryp-quick-val');
        renderQuick();
        return;
      }
      var add = e.target.closest('[data-ryp-quick-add]');
      if (add && !add.disabled) {
        var p = PRODUCTS[quickHandle];
        var v = p && matchVariant(p, quickChoice);
        if (!v) return;
        var srcBtn = quickSrcBtn;
        // feedback on the panel the shopper is looking at, and on the tile behind it
        quickEl.querySelectorAll('[data-ryp-quick-add]').forEach(function (b) {
          b.disabled = true;
          b.textContent = 'Adding…';
        });
        var pending = addVariant(v.id, srcBtn, 'quick_view');
        if (pending && pending.then) pending.then(closeQuick);
        else closeQuick();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !quickEl.hidden) closeQuick();
    });
  }

  var SPINNER = '<svg class="ryp-cart__spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"></circle><path d="M12 2a10 10 0 0 1 10 10"></path></svg>';
  /* `source` names where the add came from — 'quick_view', 'upsell'. It is
     reported on a DOM event rather than captured here: this drawer is shared by
     twelve templates and each one owns its own PostHog prefix, so the drawer
     cannot know which event name to emit. Pages listen for `ryp:cart-add` and
     capture it under their own prefix. */
  function addVariant(id, btn, source) {
    if (busy) return;
    busy = true;
    /* No ryp-cart--loading here on purpose: the tile runs its own spinner and
       dimming the whole body would bury it. But the checkout guard reads
       `busy`, so without a matching class the button would sit there looking
       enabled and do nothing when clicked. This dims just that button. */
    root.classList.add('ryp-cart--busy');
    if (btn) { btn.classList.add('is-loading'); btn.innerHTML = SPINNER; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function () {
        /* Stamp the PostHog id onto the cart — see layout/theme.liquid. This
           drawer talks to /cart/add.js directly and dispatches no cart event,
           so nothing there can observe this add. Not returned: the drawer just
           re-renders, there is no navigation to outrun. */
        if (window.rfStampCart) rfStampCart();
        document.dispatchEvent(new CustomEvent('ryp:cart-add', {
          detail: { id: parseInt(id, 10), source: source || 'drawer' }
        }));
        /* Same reason afterMutate() kicks: this add goes straight to
           /cart/add.js, so reformly-free-gifts.js never sees a
           `liquid-ajax-cart:request-end` and never reconciles. Adding a kit
           from the drawer's recommendations therefore earned no gifts at all,
           while adding the same kit from its PDP did — the hero posts the
           gifts itself.

           Forced for the same reason as the removal: nothing else covers a
           drawer add, so the staleness guard must not swallow it. */
        kickLiquidAjaxCart(true);
        return fetchCart();
      })
      .catch(function () { })
      .then(function () {
        busy = false;
        root.classList.remove('ryp-cart--busy');
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); btn.textContent = 'Added'; }
      });
  }

  /* Show the panel, no fetch. Split out of open() so a caller that has just
     refreshed the cart can reveal an already-correct drawer instead of paying
     for a second GET — see the instant:add-to-cart listener at the bottom.
     A function rather than an argument on open(): rypCart.open is handed
     straight to .then() in several sections, which would pass the resolved
     cart as that argument and silently skip the fetch. */
  function showPanel() {
    root.classList.remove('ryp-cart--closing');
    root.classList.add('ryp-cart--open');
    /* Adopt the maison drawer's open-state class rather than just reacting to
       it. reformly-scratch-card.css:521 hides its overlay with
       `html.js-ajax-cart-drawer-opened .rsc-overlay`, and the scratch card is
       on reformly-pick-a-card, which used to render maison and now renders
       this drawer. Setting it here keeps that contract; close() clears it.
       Added AFTER ryp-cart--open so the observer below sees an open drawer and
       does not treat this as a legacy trigger. */
    document.documentElement.classList.add('js-ajax-cart-drawer-opened');
    document.documentElement.style.overflow = 'hidden';
    startGiftAuto();
  }

  function open() {
    showPanel();
    /* The rail has no measurable width until the panel is on screen, so this
       is the earliest it can be built. See bootMoreRails below. */
    scheduleMoreRailBoot();
    /* A refresh triggered by the add is already in flight and will render when
       it lands. The board PDP and the bundle builder both call open() from
       their own add handler, and the add also reaches the listener at the
       bottom of this file — without this the same cart is fetched twice. */
    if (openingAfterAdd) return;
    /* The panel is visible immediately but fetchCart() is async, so until it
       resolves the drawer paints whatever the LAST render left — an empty cart
       the first time it opens. Mark it loading for that window so the buyer
       sees a pending cart rather than a wrong one, and cannot check out from a
       view that has not caught up yet. */
    root.classList.add('ryp-cart--loading');
    fetchCart()
      .catch(function () { })
      .then(function () { root.classList.remove('ryp-cart--loading'); });
  }
  function close() {
    /* Released FIRST, unconditionally, before the guard below can return
       early — no path out of the drawer may leave the page unscrollable.

       Only our own lock and our own class. NOT body.overflow-hidden: that one
       belongs to details-modal.js:31 and global.js:553 (the menu drawer), and
       close() also runs from afterMutate() and enforceInvariants() when a
       sweep empties the cart — which can happen while a modal is legitimately
       holding that class. Dawn's drawer was the other thing setting it, and
       cart-drawer.js is no longer loaded at all. */
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('js-ajax-cart-drawer-opened');
    if (!root.classList.contains('ryp-cart--open') || root.classList.contains('ryp-cart--closing')) return;
    root.classList.add('ryp-cart--closing');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      root.classList.remove('ryp-cart--open', 'ryp-cart--closing');
      document.documentElement.style.overflow = '';
      stopGiftAuto();
      if (panel) panel.removeEventListener('animationend', finish);
    };
    if (panel) panel.addEventListener('animationend', finish);
    setTimeout(finish, 360); // fallback if animationend doesn't fire
  }

  // Delegated events inside the drawer
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ryp-close]')) { close(); return; }
    var q = e.target.closest('[data-ryp-qty]');
    if (q) {
      var line = parseInt(q.getAttribute('data-line'), 10);
      var row = q.closest('.ryp-cart__line');
      var cur = parseInt(row.querySelector('.ryp-cart__qty-num').textContent, 10) || 1;
      var next = q.getAttribute('data-ryp-qty') === 'inc' ? cur + 1 : cur - 1;
      // decrementing the board to 0 must remove its whole bundle (membership + gifts)
      if (next <= 0) {
        var qrm = row.querySelector('[data-ryp-remove]');
        var qh = qrm ? (qrm.getAttribute('data-ryp-handle') || '') : '';
        var qv = qrm ? parseInt(qrm.getAttribute('data-ryp-variant'), 10) : 0;
        if (isBoard(qh, qv)) { removeBundle(qv); return; }
      }
      changeLine(line, Math.max(0, next), q.getAttribute('data-ryp-key'));
      return;
    }
    var rm = e.target.closest('[data-ryp-remove]');
    if (rm) {
      var rh = rm.getAttribute('data-ryp-handle') || '';
      var rv = parseInt(rm.getAttribute('data-ryp-variant'), 10);
      if (isBoard(rh, rv)) { removeBundle(rv); }
      else { changeLine(parseInt(rm.getAttribute('data-ryp-remove'), 10), 0, rm.getAttribute('data-ryp-key')); }
      return;
    }
    var qk = e.target.closest('[data-ryp-quick]');
    if (qk) { openQuick(qk.getAttribute('data-ryp-quick')); return; }
    var up = e.target.closest('[data-ryp-upsell-add]');
    if (up) {
      // Add/remove toggle — adds the default variant straight away. Colour/size
      // is changed through quick view (tap the image or the name).
      var uh = up.getAttribute('data-ryp-tile-handle');
      var existing = uh && lastCart ? lastCart.items.filter(function (it) { return it.handle === uh; })[0] : null;
      if (existing) changeLine(lastCart.items.indexOf(existing) + 1, 0, existing.key);
      else addVariant(up.getAttribute('data-ryp-upsell-add'), up, 'upsell');
      return;
    }
    var co = e.target.closest('[data-ryp-checkout]');
    if (co) {
      /* Do not leave for checkout while a cart request is still in flight. The
         loading dim covers .ryp-cart__body only, and this button lives in the
         footer — so mid-mutation it stayed clickable and the buyer could land
         on checkout holding a cart that does not match what they were looking
         at. Harmless for the ATC path (that add is already resolved before the
         drawer opens) but not for qty changes and upsell adds. */
      if (busy || root.classList.contains('ryp-cart--loading')) return;

      /* Pending state while the browser navigates.

         Leaving for checkout is a full page load, and on a slow connection the
         gap between the tap and anything changing on screen is long enough that
         buyers tap again — which does nothing useful and reads as broken. The
         class swaps the label for a spinner and blocks further presses.

         Nothing resets it: this element is going away with the page. The one
         case where it would linger is a back-navigation restoring the drawer
         from bfcache, so pageshow clears it below. */
      co.classList.add('is-loading');
      co.setAttribute('aria-busy', 'true');

      var go = function () { window.location.href = '/checkout' + emailParam(); };


      /* checkout_clicked — our own intent event, fired here rather than
         inferred from Shopify's pixel.

         Why it exists: `checkout_started` comes from the checkout pixel
         (docs/reformly-checkout-pixel.js) and goes missing often enough that
         docs/posthog-checks.md carries two queries for chasing it (§3, §4).
         The funnel is strictly ordered, so a lost pixel event drops the whole
         session at that step while its purchase still counts in Total
         Purchases — the two disagree and nobody can say which is right.

         This does NOT replace checkout_started. Both are kept, so the gap
         between them measures the pixel's loss rate instead of hiding it:

           add_to_cart -> checkout_clicked (ours) -> checkout_started -> purchase

         Unprefixed, like checkout_started and purchase_completed, because the
         drawer is shared by every template — a per-page prefix would mean
         picking an arbitrary page to own a cross-page event. Tiles scope it by
         session, the same way the purchase tiles already do.

         THE FIX IS THE 150ms HOLD BELOW, not this option.

         posthog-js puts a capture on a request queue rather than sending it
         inline. Originally this called window.location.href on the very next
         line, so the page was torn down in the same tick and the queued event
         died with it — no error, nothing in the console, indistinguishable
         from the capture never running. A localStorage probe in the handler
         proved the code was fine: reached_handler, has_capture and
         capture_called all true, nothing thrown, and still no event. Adding
         the deferral alone made it land.

         Everything that arrived from this page fits that rule — console calls,
         $autocapture on add-to-cart, every rx_* event: none of them navigate.
         $pageleave arrives only because posthog flushes it on pagehide.

         send_instantly issues the request immediately instead of waiting for
         the queue poll, so delivery no longer depends on an interval we do not
         control. Belt and braces over the hold, not a replacement for it.

         Guarded because posthog may be blocked, and a dead analytics call must
         never stop a buyer reaching checkout. */
      /* Fire the event, then leave. Split into a function so it can run either
         immediately or after a cart refresh that is still in flight. */
      var fire = function () {
        try {
          if (window.posthog && posthog.capture) {
            posthog.capture('checkout_clicked', {
              source: 'drawer',
              template: root.getAttribute('data-ryp-template') || null
            }, { send_instantly: true });
            /* send_instantly issues the request inline, but the hold covers it
               still being on the wire. The original version called
               window.location in the same tick and the event never survived —
               that, not the option, was the bug. */
            setTimeout(go, 150);
            return;
          }
        } catch (err) { }
        /* posthog missing, blocked, or threw — go to checkout anyway. A dead
           analytics call must never cost a sale. */
        go();
      };

      /* Fires immediately. No cart read, and no cart figures on the event.

         It used to report item_count / cart_total / currency read at click
         time. That never worked: the value was either lastCart (the last
         RENDERED cart, one add behind when the buyer clicks fast) or it waited
         on a fetch behind a 400ms cap that kept expiring — shipping a wrong
         number next to a flag saying it might be wrong.

         Dropped rather than fixed, because nothing downstream consumed them.
         This event answers exactly one question: did the buyer press checkout.
         It exists to measure how often the checkout pixel loses that session
         (see above). Money is already authoritative in purchase_completed and
         in the Shopify order itself; a cart snapshot taken mid-click is a
         worse source and was never joined against anything.

         Removing them removes the read, so the click holds only for the 150ms
         queue flush. */
      fire();
      return;

    }
  });

  /* Coming BACK from checkout restores this page from bfcache with the DOM
     exactly as it was left — including a checkout button still spinning. */
  window.addEventListener('pageshow', function () {
    var co = root.querySelector('[data-ryp-checkout]');
    if (co) { co.classList.remove('is-loading'); co.removeAttribute('aria-busy'); }
  });

  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Free-gift carousel dots
  var giftCarousel = root.querySelector('[data-ryp-gift-carousel]');
  var giftDots = root.querySelectorAll('[data-ryp-gift-dots] .ryp-cart__gift-dot');
  if (giftCarousel && giftDots.length) {
    var giftTimer = null;
    function goTo(i) {
      giftCarousel.scrollTo({ left: i * giftCarousel.clientWidth, behavior: 'smooth' });
    }
    function autoAdvance() {
      var cur = Math.round(giftCarousel.scrollLeft / giftCarousel.clientWidth);
      goTo((cur + 1) % giftDots.length);
    }
    function startAuto() {
      stopAuto();
      giftTimer = setInterval(autoAdvance, 4000);
    }
    function stopAuto() { if (giftTimer) { clearInterval(giftTimer); giftTimer = null; } }
    startGiftAuto = startAuto; // driven by cart open/close
    stopGiftAuto = stopAuto;
    giftCarousel.addEventListener('scroll', function () {
      var i = Math.round(giftCarousel.scrollLeft / giftCarousel.clientWidth);
      giftDots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }, { passive: true });
    giftDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAuto(); // manual control stops auto-rotate
        goTo(parseInt(dot.getAttribute('data-i'), 10) || 0);
      });
    });
    function step(delta) {
      stopAuto();
      var cur = Math.round(giftCarousel.scrollLeft / giftCarousel.clientWidth);
      goTo(Math.max(0, Math.min(giftDots.length - 1, cur + delta)));
    }
    var gPrev = root.querySelector('[data-ryp-gift-prev]');
    var gNext = root.querySelector('[data-ryp-gift-next]');
    if (gPrev) gPrev.addEventListener('click', function () { step(-1); });
    if (gNext) gNext.addEventListener('click', function () { step(1); });
    // Stop auto-rotate once the user taps/swipes the carousel
    giftCarousel.addEventListener('pointerdown', stopAuto);
  }

  // Public API for page triggers
  // quickView is exposed for pages that show the same upsell products outside
  // the drawer — the Luna bestsellers rail opens this modal from its cards.
  // Handles not present in PRODUCTS are ignored by openQuick, so a page that
  // lists a product the drawer does not carry simply gets no modal.
  /* giftIds: the hidden ReformerX gifts, published so a page ATC can post them
     in the SAME /cart/add.js call as the board.

     reformly-free-gifts.js normally adds them, but only when it observes a
     liquid-ajax-cart request — and the board PDP adds with a raw fetch, which
     that library never sees. Without this the drawer opens showing a board and
     no gifts until the next page load.

     Sourced here rather than repeated in the hero because this file already
     owns the list for the drawer (REFORMERX_GIFTS) and is loaded on every
     template that uses this cart. free-gifts.js still reconciles afterwards and
     finds nothing missing.

     Not read from custom.cart_item_free_gifts: that metafield still points at
     the ORIGINAL gift products, which were duplicated — the live gifts are the
     `-digital-product-copy` handles. Admin resolves the old references so the
     names look right there, but on the storefront `.value` comes back empty. */
  window.rypCart = { open: open, close: close, refresh: fetchCart, quickView: openQuick, giftIds: REFORMERX_GIFTS };

  /* ---- Open when something else on the page adds to the cart ---------------

     This drawer is not the only thing that writes the cart, and the other
     writers do not agree on how they do it:

       Dawn's product-form.js        fetch /cart/add.js, then renderContents()
       reformly-free-gifts.js:1248   raw fetch, board + gifts in one call
       maison-sticky-cart.liquid     its own fetch + a manual event
       maison-variant-selector       ditto

     Rather than teach each of them about this drawer, listen to the one signal
     they all already produce. layout/theme.liquid:515 wraps window.fetch and
     dispatches `instant:add-to-cart` after ANY successful /cart/add:

         if (args[0].includes('/cart/add') && response.ok)
           document.dispatchEvent(new Event('instant:add-to-cart'));

     That patch lives in the layout, not in the maison drawer, so it survives
     the drawer swap. Its `unless` gate excludes exactly the templates that
     already used this drawer and open it themselves, so this listener only
     ever runs where nothing else was opening anything.

     What this replaces: cart-drawer-scripts.liquid held the equivalent
     listener for the maison drawer, and that snippet is rendered only by
     maison-cart-drawer.liquid:3704 — it goes away with the section.

     fetch-then-show rather than open(): the add has just landed, so a GET
     /cart.js here is ~150ms and the drawer appears already correct. open()
     would show the pre-add cart behind a loading class and swap it a moment
     later, which is the flash this avoids. */
  /* ---- Keep liquid-ajax-cart's own cart fresh -----------------------------

     The gift engines do not listen for adds. They listen for
     `liquid-ajax-cart:request-end` and then read window.liquidAjaxCart.cart:

       sections/main-product.liquid:3369   metafield gifts (+4 more copies)
       assets/reformly-free-gifts.js:1080  the reconciler

     liquid-ajax-cart does NOT patch fetch, and no product form carries a
     data-ajax-cart-* binding, so a Dawn add never produces that event by
     itself. What produced it was cart-drawer-scripts.liquid:66 — on
     `instant:add-to-cart` it called `liquidAjaxCart.update()`, and THAT
     request is what fired request-end and made the gifts appear. That snippet
     is rendered only by the maison drawer, so the swap took it away and gifts
     silently stopped being added.

     So the kick has to be re-issued here. It is cheap now: with the maison
     section gone nothing is registered as [data-ajax-cart-section], so
     update({}) is a bare POST /cart/update.js rather than a full drawer
     render.

     The guard is the same idea as the `handled` test that snippet used, which
     read window.__lacInFlight / __lacLastRequest — both defined inside the
     maison drawer, so both gone. Tracked locally instead. It matters because
     reformly-free-gifts.js:1299 already calls update() itself after its
     batched board add; without this we would fire a second one for the same
     add and hand handleCartChange() a duplicate trigger. */
  var lacInFlight = 0;
  var lacLast = 0;
  document.addEventListener('liquid-ajax-cart:request-start', function () {
    lacInFlight++;
    lacLast = Date.now();
  });
  document.addEventListener('liquid-ajax-cart:request-end', function (e) {
    if (lacInFlight > 0) lacInFlight--;
    lacLast = Date.now();
    /* The gift engines add their lines through liquid-ajax-cart, so those
       lines appear AFTER the refresh this drawer did for the original add.
       Without re-reading here the drawer shows the board and no gifts until
       it is closed and reopened. A GET /cart.js does not go through the
       library, so this cannot feed itself. */
    var st = e.detail && e.detail.requestState;
    var ok = st && st.responseData && st.responseData.ok;

    /* `update` as well as `add`. The gift engines REMOVE lines through
       liquid-ajax-cart too — a swept gift is an update, not an add — and
       without re-reading here the drawer kept showing a gift the server had
       already deleted. That is the "it was removed, the grid just didn't
       update" case: the data was right, the panel was stale.

       Still cannot feed itself: fetchCart() is a GET /cart.js, which does not
       go through the library and so emits no request-end. */
    if (ok && (st.requestType === 'add' || st.requestType === 'update')) {
      fetchCart().catch(function () { });
    }

    if (ok && st.requestType === 'add') {
      /* Parity with cart-drawer-scripts.liquid:65, which opened the maison
         drawer on any LAC add. Only where that snippet used to run — see the
         flag's definition in layout/theme.liquid. Skipped while the
         instant:add-to-cart path is mid-flight so one add cannot open twice. */
      if (window.rypLegacyOpenOnAdd && !openingAfterAdd) showPanel();
    }
  });

  /* `force` is for mutations THIS drawer made. The staleness guard below
     assumes something else already covered the cart change — true for an add,
     where reformly-free-gifts.js issues its own update(), and false for a
     removal, where nothing else runs at all. Without the override, removing a
     line within 2s of any cart activity skipped the kick and the orphaned gift
     was never swept — intermittently, depending on timing. */
  function kickLiquidAjaxCart(force) {
    if (!window.liquidAjaxCart || !window.liquidAjaxCart.update) return;
    /* Deferred, not immediate. reformly-free-gifts.js:1299 issues its own
       update() from the .then() of its batched add, a few ms after the fetch
       patch dispatches this event — running now would beat it and fire two
       requests for one add. Re-checking the guard after the delay lets its
       request claim the slot. */
    setTimeout(function () {
      if (lacInFlight > 0) return;                        // its own request is running
      if (!force && Date.now() - lacLast < 2000) return;  // one just finished — that add is covered
      window.liquidAjaxCart.update({});
    }, 300);
  }

  var openingAfterAdd = false;
  document.addEventListener('instant:add-to-cart', function () {
    /* Before the early-returns below: the gift engines need this even when
       the add came from this drawer's own upsell tiles. */
    kickLiquidAjaxCart();
    /* busy = our own add/quantity change, which refetches and re-renders on
       its own; opening again would fire a duplicate GET for the same state. */
    if (busy || openingAfterAdd) return;
    /* The sticky cart and the variant selector dispatch this event themselves
       AND go through the patched fetch, so one add arrives twice. Drop the
       second while the first is still resolving. */
    openingAfterAdd = true;
    fetchCart()
      .catch(function () { })
      .then(function () {
        openingAfterAdd = false;
        showPanel();
      });
  });

  /* Legacy open-only triggers. Several sections open the cart by setting the
     class the MAISON drawer listened for and nothing else — e.g.
     reformly-july4-hero.liquid:194. With that drawer gone the class means
     nothing, so the button looks dead. Watching <html> covers all of them at
     once without editing cart files, which CLAUDE.md puts off limits.

     The class is left in place rather than stripped — showPanel() sets it
     itself and close() clears it, so it is this drawer's open-state marker and
     other CSS can still key off it. Triggers that ADD and then set it are
     already handled above; this sees the drawer open and does nothing.

     Fires on every <html> class change, including liquid-ajax-cart's own
     js-ajax-cart-processing/empty toggles. One classList.contains per toggle. */
  new MutationObserver(function () {
    if (!document.documentElement.classList.contains('js-ajax-cart-drawer-opened')) return;
    if (!root.classList.contains('ryp-cart--open')) open();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  /* ---------- "Looking for more" rail ----------

     The row is a Swiper using the same `rails` preset as the home Bestsellers
     carousel; reformly-bp-swiper.js owns the init. All this does is tell it
     when to run, because the drawer breaks two of that script's assumptions.

     ONE: the markup is replaced. liquid-ajax-cart re-renders the whole drawer
     on every cart change, so the rail that was initialised is detached and a
     virgin one takes its place — no ready flag, and the lazyBoot
     IntersectionObserver is not watching it because it only ever observed the
     nodes present at load.

     TWO: it has no width until it is opened. The panel is off-canvas, so a
     Swiper built before that measures a zero-width viewport and lays every
     slide at the same offset.

     Hence boot after each render AND on open. build() is idempotent, so the
     second of those costs a flag check when nothing has changed. */
  var moreSwipers = [];

  /* build() announces each instance it creates. Collected so the detached
     ones can be destroyed: an orphaned Swiper keeps a window resize listener,
     and that listener holds the only remaining reference to the replaced
     drawer markup — so without this every cart change would leak a whole
     subtree plus a handler that re-measures it on resize. */
  document.addEventListener('bp:swiper', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ryp-more')) {
      moreSwipers.push(e.detail.swiper);
    }
  });

  function bootMoreRails() {
    moreSwipers = moreSwipers.filter(function (sw) {
      if (sw.el && sw.el.isConnected) return true;
      // cleanStyles: false — the element is already out of the document.
      try { sw.destroy(true, false); } catch (err) {}
      return false;
    });

    /* NATIVE SCROLLING ON TOUCH, transform on pointer devices.

       A transform-driven Swiper runs its movement from JS on the main thread
       for every touchmove; a native overflow scroller runs on the compositor
       with the OS's own momentum. On a phone the second is smoother and no
       amount of tuning closes the gap — the row was measurably better before
       the conversion, which is this difference and not a configuration
       mistake.

       cssMode is Swiper's own answer: the wrapper becomes `overflow: scroll`
       and the library drives scrollLeft instead of a transform, so the
       browser scrolls it exactly as it scrolled the hand-rolled version.
       Combined with freeMode it also sets `scroll-snap-type: none`, so
       nothing re-aligns mid-gesture — the bug that made the old bar drag
       hop between tiles.

       What cssMode costs is simulateTouch: there is no transform to drag, so
       a mouse cannot pull the TILES. That is why this is gated on pointer
       rather than applied everywhere — a fine pointer keeps the transform
       build and gets both the tile drag and the scrollbar, neither of which
       a touch device needs or shows.

       Stamped onto data-bp-opts rather than passed as an argument because
       reformly-bp-swiper.js is declarative: it reads this attribute at
       build(). Merged into whatever the markup already declares so the
       spaceBetween and freeMode overrides there survive. */
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var rails = root.querySelectorAll('[data-ryp-more-swiper]');
    for (var r = 0; r < rails.length; r++) {
      var rail = rails[r];
      if (rail.dataset.bpSwiperReady === '1') continue;

      if (!fine) {
        var o = {};
        try { o = JSON.parse(rail.dataset.bpOpts || '{}'); } catch (err) {}
        o.cssMode = true;
        rail.dataset.bpOpts = JSON.stringify(o);
      }
      // Only now does the shared booter see it. See the note in the markup.
      rail.dataset.bpSwiper = rail.dataset.rypMoreSwiper;
    }

    if (typeof window.bpSwiperBoot === 'function') {
      window.bpSwiperBoot(root);
    }
    // Already built but reopened at a new width: re-measure rather than rebuild.
    for (var i = 0; i < moreSwipers.length; i++) {
      try { moreSwipers[i].update(); } catch (err) {}
    }
  }

  /* Two frames: one for the markup swap to land, one for layout to settle, so
     Swiper measures real widths rather than the pre-paint ones. */
  function scheduleMoreRailBoot() {
    requestAnimationFrame(function () { requestAnimationFrame(bootMoreRails); });
  }
  document.addEventListener('liquid-ajax-cart:request-end', scheduleMoreRailBoot);

  /* Theme header cart icon. Its handler is an inline onclick in
     sections/header.liquid that toggles `js-ajax-cart-drawer-opened` — the
     class the MAISON drawer listens to. On a template using this drawer that
     class opens nothing, so the icon looks dead. Intercepted here in the
     capture phase so it runs before the inline handler, and header.liquid
     stays untouched (it is shared by every page on the store).

     Only binds where the header actually renders; most templates on this
     drawer hide it. */
  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!icon) return;
    e.preventDefault();
    e.stopPropagation();
    // No need to clear js-ajax-cart-drawer-opened here any more: showPanel()
    // owns that class now and sets it as part of opening.
    open();
  }, true);

  /* Prime cart state so the count badge is correct on load, and so the orphan
     sweep in render() runs once per page as it always has.

     Seeded from the cart Shopify already embedded rather than fetched.
     layout/theme.liquid:528 emits `{{ cart | json }}` as
     [data-ajax-cart-initial-state] on every template — it is liquid-ajax-cart's
     own initial state and is byte-identical in shape to /cart.js. Now that this
     drawer renders site-wide, fetching here would be one extra XHR on every
     page of the store for data already in the document.

     Falls back to the request if the element is missing or unparseable, which
     is also what happens on any layout that does not emit it. */
  var seedEl = document.querySelector('[data-ajax-cart-initial-state]');
  var seeded = false;
  if (seedEl) {
    try {
      var seedCart = JSON.parse(seedEl.textContent);
      /* `handle` is checked, not assumed: render() runs enforceInvariants(),
         whose gift-trigger test is a handle lookup. A payload without it would
         read as "no qualifying product" and DELETE every gift line. Cheap
         guard on a path that can destroy a cart. */
      if (seedCart && Array.isArray(seedCart.items) &&
        (!seedCart.items.length || 'handle' in seedCart.items[0])) {
        render(seedCart);
        seeded = true;
      }
    } catch (e) { }
  }
  if (!seeded) fetchCart().catch(function () { });

  /* An add that landed before this script ran.

     This file is `defer` at the end of the drawer snippet, so between the
     drawer being parsed and this line executing there is a window in which a
     click can add to the cart with no instant:add-to-cart listener attached —
     the add succeeds and nothing opens. assets/product-form.js sets this flag
     on that path (it tests window.rypCart, which is only defined here). Pick
     it up and open, so the buyer still gets the confirmation they expect. */
  if (window.rypPendingOpen) {
    window.rypPendingOpen = false;
    fetchCart().catch(function () { }).then(showPanel);
  }
})();
